export function normalizeChatId(value = '') {
  return String(value).replace('@c.us', '').replace(/[^\d]/g, '');
}

export function formatPhoneForDisplay(value = '') {
  const normalized = normalizeChatId(value);
  return normalized ? `+${normalized}` : '-';
}

export function toTitleCase(value = '') {
  return String(value)
    .replace(/[_-]/g, ' ')
    .trim()
    .replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}

export function getContactInitials(name = '') {
  const cleanName = String(name).trim();
  if (!cleanName || cleanName.toLowerCase() === 'unknown') return 'U';

  return cleanName
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('') || 'U';
}

export function buildContactProfile(record = {}) {
  const phone = normalizeChatId(record.phone || record.mobileNumber || record.chatId || record.waId || record.wa_id);
  const rawName = record.name || record.profileName || record.displayName || '';
  const name = rawName.trim() || 'UNKNOWN';
  const status = toTitleCase(record.status || (record.intervenedBy ? 'intervened' : 'inactive')) || 'Inactive';

  return {
    id: record._id || record.id || record.chatId || phone,
    name,
    phone,
    displayPhone: formatPhoneForDisplay(phone),
    status,
    source: String(record.source || 'organic').toUpperCase(),
    lastActivity: record.lastActivityAt || record.lastActivity || record.updatedAt || record.createdAt || null,
    templateMessages: Number(record.templateMessages || record.templateMessageCount || 0),
    sessionMessages: Number(record.sessionMessages || record.messageCount || 0),
    unresolvedQueries: Number(record.unresolvedQueries || record.unresolvedQueryCount || 0),
    firstMessage: record.firstMessage || record.lastMessage || '.....',
    waConversation: record.waConversation || record.conversationStatus || 'Inactive',
    mauStatus: record.mauStatus || (record.optedIn === false ? 'Inactive' : 'Active'),
    incoming: record.incoming || (record.blocked ? 'Blocked' : 'Allowed'),
    optedIn: record.optedIn !== false,
    tags: Array.isArray(record.tags) ? record.tags : [],
    productInterest: record.productInterest || '-',
    email: record.email || '',
    notes: record.notes || '',
    raw: record,
  };
}

export function filterContacts(records = [], filters = {}) {
  const search = String(filters.search || '').trim().toLowerCase();
  const source = filters.source || 'all';
  const status = filters.status || 'all';
  const tag = filters.tag || 'all';

  return records.filter((record) => {
    const profile = buildContactProfile(record);
    const searchable = [
      profile.name,
      profile.phone,
      profile.email,
      profile.source,
      profile.status,
      profile.tags.join(' '),
    ].join(' ').toLowerCase();

    const matchesSearch = !search || searchable.includes(search);
    const matchesSource = source === 'all' || profile.source.toLowerCase() === String(source).toLowerCase();
    const matchesStatus = status === 'all' || profile.status.toLowerCase() === String(status).toLowerCase();
    const matchesTag = tag === 'all' || profile.tags.map((item) => item.toLowerCase()).includes(String(tag).toLowerCase());

    return matchesSearch && matchesSource && matchesStatus && matchesTag;
  });
}

export function getUniqueTags(records = []) {
  return Array.from(new Set(records.flatMap((record) => buildContactProfile(record).tags))).sort();
}
